<div class="stacked-bar-chart">
  @if (rowLabelHeader || valuesHeader) {
    <div class="chart-header">
      <span class="header-label">{{ rowLabelHeader }}</span>
      <span class="header-values">{{ valuesHeader }}</span>
    </div>
  }

  <div class="chart-rows">
    @for (row of rows; track row.name) {
      <div class="chart-row">
        <div class="bar-wrapper">
          <span class="row-label">{{ row.name }}</span>
          <div class="bar-container">
            @for (segment of segmentTypes; track segment.key) {
              @if (hasSegmentValue(row, segment.key)) {
                <div
                  class="bar-segment"
                  [ngClass]="segment.cssClass"
                  [style.width.%]="getSegmentWidth(row, segment.key)"
                  [matTooltip]="
                    (segment.label | translate) + ': ' + getSegmentValue(row, segment.key)
                  "
                ></div>
              }
            }
          </div>
        </div>
        @if (showBadges) {
          <div class="badges-container">
            @for (segment of segmentTypes; track segment.key) {
              @if (hasSegmentValue(row, segment.key)) {
                <span class="value-badge" [ngClass]="segment.cssClass">
                  {{ getSegmentValue(row, segment.key) }}
                </span>
              }
            }
          </div>
        }
      </div>
    }
  </div>

  @if (showLegend) {
    <div class="chart-legend">
      @for (segment of segmentTypes; track segment.key) {
        <div class="legend-item">
          <span class="legend-dot" [ngClass]="segment.cssClass"></span>
          <span class="legend-label">{{ segment.label | translate }}</span>
        </div>
      }
    </div>
  }
</div>
